import { combineEpicsFromImport } from '../../lib/Utils'

import epics from './epics/index'

export default combineEpicsFromImport(epics)
